import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Divider,
  Paper,
  Stack,
} from "@mui/material";
import { Close as CloseIcon, Info as InfoIcon } from "@mui/icons-material";
import {
  addExpense,
  addOpeningBalance,
  getEODBalance,
} from "../../services/OuteletOrder/OutletFoodOrder.service";
import { showErrorToast, showSuccessToast } from "../../utils/toast";

export default function EndDayPopup({ open = true, onClose = () => {} }) {
  // State for all form fields and data

  const [isFinalized, setIsFinalized] = useState(false);

  const [formData, setFormData] = useState({
    openingTime: "",
    openingBalance: 0,
    todayOrders: 0,
    todaySales: 0,
    totalDiscount: 0, // ✅ ADD THIS
    totalCashReceived: 0,
    totalUpiReceived: 0,
    expectedCash: 0,
    staffFoodExpense: "",
    rmPurchaseExpense: "",
    otherExpense: "",
    salaryExpense: "",
    sortCash: "",
    cashWithdraw: "",
    endOfDayBalance: "",
    note: "",
  });

  




 
const handlePrint = async () => {
  try {
    const res = await getEODBalance();

    console.log("EOD RESPONSE FULL:", res);

    if (!res?.success || !res?.data) {
      showErrorToast("EOD data not found");
      return;
    }

    const {
      date,
      sold_items = [],
      raw_usage = [],
      total_sales = 0,
    } = res.data;

    console.log("SOLD ITEMS:", sold_items);

    // ================= CONSTANTS =================
    const ITEM_WIDTH = 15;
    const QTY_WIDTH = 3;
    const RATE_WIDTH = 7;
    const AMT_WIDTH = 10;

    const RAW_ITEM_WIDTH = 20;
    const RAW_QTY_WIDTH = 10;

    const wrapText = (text, width) => {
      const lines = [];
      let value = String(text || "");
      while (value.length > width) {
        lines.push(value.substring(0, width));
        value = value.substring(width);
      }
      if (value.length) lines.push(value);
      return lines;
    };

    // ================= CATEGORY SORT =================
    const categoryPriority = {
      COMBO: 1,
      BURGER: 2,
      PIZZA: 3,
      COFFEE: 4,
      OTHERS: 5,
    };

    const sortedSoldItems = [...sold_items].sort(
      (a, b) =>
        (categoryPriority[a.category] || 99) -
        (categoryPriority[b.category] || 99)
    );


    // ==================Third Receipt logic ============================
    const {
  // date,
  opening_balance = 0,
  total_cash = 0,
  cash_withdraw = 0,
  staff_food_expense = 0,
  salary_expense = 0,
  rm_purchase_expense = 0,
  other_expense = 0,
  mithinial_expense = 0,
  end_of_day_balance = 0,
  sort_cash = "₹0",
  total_discount = 0,
  total_upi = 0
} = res.data;

const totalExpense =
  Number(cash_withdraw) +
  Number(staff_food_expense) +
  Number(salary_expense) +
  Number(rm_purchase_expense) +
  Number(other_expense) +
  Number(mithinial_expense);

const openingCash = Number(opening_balance);
const cashSales = Number(total_cash);
const closingCash = Number(end_of_day_balance);
const upiSales = Number(total_upi);
const totalSalesCombined = cashSales + upiSales;






    // ================= SOLD ITEMS RECEIPT =================
    let lastCategory = null;
    const soldItemLines = [];

    sortedSoldItems.forEach((item) => {
      if (!item?.item_name) return;

      const currentCategory = item.category;

      if (currentCategory !== lastCategory) {
        if (lastCategory !== null) {
          soldItemLines.push("----------------------------------------");
        }
        soldItemLines.push(`(${currentCategory})`);
        lastCategory = currentCategory;
      }

      const nameLines = wrapText(item.item_name, ITEM_WIDTH);
      const qty = Number(item.quantity || 0);
      const rate = Number(item.rate || 0);
      const amount = Number(item.amount || 0);

      const firstLine =
        nameLines[0].padEnd(ITEM_WIDTH) +
        qty.toString().padStart(QTY_WIDTH) +
        rate.toFixed(2).padStart(RATE_WIDTH) +
        amount.toFixed(2).padStart(AMT_WIDTH);

      soldItemLines.push(firstLine);

      nameLines.slice(1).forEach((line) => {
        soldItemLines.push(
          line.padEnd(ITEM_WIDTH) +
            "".padStart(QTY_WIDTH) +
            "".padStart(RATE_WIDTH) +
            "".padStart(AMT_WIDTH)
        );
      });
    });

    soldItemLines.push("----------------------------------------");

    const salesReceipt = `
           Byting Korner
        END OF DAY REPORT
----------------------------------------
Date : ${date}
----------------------------------------
Item             Qty   Rate   Amount
----------------------------------------
${soldItemLines.join("\n")}
TOTAL SALES : ₹${Number(total_sales).toFixed(2)}
----------------------------------------
        Shift Closed Successfully
----------------------------------------
`;

    console.log("SALES RECEIPT:", salesReceipt);

    // ================= RAW USAGE RECEIPT =================
    const rawUsageArray = Array.isArray(raw_usage)
      ? raw_usage
      : Object.values(raw_usage || {});

    const rawUsageLines =
      rawUsageArray.length === 0
        ? "No raw usage"
        : rawUsageArray
            .map((row) => {
              const name = String(row.raw_item || "ITEM")
                .replace(/_/g, " ")
                .toUpperCase()
                .padEnd(RAW_ITEM_WIDTH);

              const qty = Number(row.quantity || 0);
              const unit = row.unit || "";

              return name + `${qty} ${unit}`.padStart(RAW_QTY_WIDTH);
            })
            .join("\n");

    const rawUsageReceipt = `
           Byting Korner
        RAW USAGE REPORT
----------------------------------------
Date : ${date}
----------------------------------------
Item                 Quantity
----------------------------------------
${rawUsageLines}
----------------------------------------
        Inventory Summary
----------------------------------------
`;

    console.log("RAW USAGE RECEIPT:", rawUsageReceipt);

    const totalSummaryReceipt = `
           Byting Korner
        TOTAL SUMMARY REPORT
----------------------------------------
Date : ${date}
----------------------------------------
Opening Cash        : ₹${openingCash.toFixed(2)}
Cash Sales          : ₹${cashSales.toFixed(2)}
----------------------------------------
Expenses
----------------------------------------
Cash Withdraw       : ₹${Number(cash_withdraw).toFixed(2)}
Staff Food          : ₹${Number(staff_food_expense).toFixed(2)}
Salary Expense      : ₹${Number(salary_expense).toFixed(2)}
RM Purchase         : ₹${Number(rm_purchase_expense).toFixed(2)}
Miscellaneous       : ₹${Number(mithinial_expense).toFixed(2)}
Other Expense       : ₹${Number(other_expense).toFixed(2)}
----------------------------------------
Total Expense       : ₹${totalExpense.toFixed(2)}
----------------------------------------
Closing Cash        : ₹${closingCash.toFixed(2)}
----------------------------------------
Cash Difference     : ${sort_cash}
----------------------------------------
Discount            : ₹${Number(total_discount).toFixed(2)}
----------------------------------------
Total Sales         : ₹${totalSalesCombined.toFixed(2)}
(Cash + UPI)        
----------------------------------------
        Shift Closed Successfully
----------------------------------------
`;

console.log("Total summary report...",totalSummaryReceipt);



    

    // ================= ANDROID PRINT =================
    if (!window.AndroidPOS || !window.AndroidPOS.printText) {
      showErrorToast("AndroidPOS bridge not available");
      return;
    }

    const printSalesId = `eod_sales_${Date.now()}`;
    const printRawId = `eod_raw_${Date.now()}`;
    const printTotalId = `eod_total_${Date.now()}`;

    window[printSalesId] = () => {
      window.AndroidPOS.printText(rawUsageReceipt, printRawId);
      delete window[printSalesId];
    };

    window[printRawId] = () => {
  window.AndroidPOS.printText(totalSummaryReceipt, printTotalId);
  delete window[printRawId];
};

    window[printTotalId] = (status) => {
      const parsed = typeof status === "string" ? JSON.parse(status) : status;
      parsed?.success
        ? showSuccessToast("EOD & Raw Usage printed")
        : showErrorToast(parsed?.message || "Print failed");
      delete window[printTotalId];
    };

    // Start printing
    window.AndroidPOS.printText(salesReceipt, printSalesId);
  } catch (error) {
    console.error("EOD print error:", error);
    showErrorToast("Failed to print EOD report");
  }
};





  


  // Calculate expected cash dynamically
  useEffect(() => {
    if (open) {
      (async () => {
        try {
          const res = await getEODBalance();
          if (res?.success && res.data) {
            const d = res.data;
            setFormData({
              openingTime: d.start_time,
              openingBalance: d.opening_balance,
              todayOrders: d.total_orders,
              todaySales: d.total_sales,
              totalDiscount: d.total_discount || 0, 
              totalCashReceived: d.total_cash,
              totalUpiReceived: d.total_upi,
              expectedCash: d.expected_cash,
              staffFoodExpense: d.staff_food_expense,
              rmPurchaseExpense: d.rm_purchase_expense,
              otherExpense: d.other_expense,
              mithinial_expense: d.mithinial_expense,
              salaryExpense: d.salary_expense,
              sortCash: d.sort_cash,
              cashWithdraw: d.cash_withdraw,
              endOfDayBalance: d.end_of_day_balance,
              note: d.note,
            });
            // If backend already returns remaining uncounted orders
            setIsFinalized(d.remaining_orders === 0);
          } else {
            console.error("❌ Failed to fetch EOD:", res?.message);
          }
        } catch (err) {
          console.error("API Error:", err);
        }
      })();
    }
  }, [open]);

  // inside EndDayPopup
  useEffect(() => {
    const openingBalance = Number(formData.openingBalance) || 0;
    const totalCash = Number(formData.totalCashReceived) || 0;

    const expectedCash = openingBalance + totalCash;

    const cashWithdraw = Number(formData.cashWithdraw) || 0;
    const salary = Number(formData.salaryExpense) || 0;
    const rmPurchase = Number(formData.rmPurchaseExpense) || 0;
    const staffFood = Number(formData.staffFoodExpense) || 0;
    const otherExpense = Number(formData.otherExpense) || 0;
    const mithinial_expense = Number(formData.mithinial_expense) || 0;
    const endOfDayBalance = Number(formData.endOfDayBalance) || 0;

    const totalExpenses =
      cashWithdraw +
      salary +
      rmPurchase +
      staffFood +
      otherExpense +
      mithinial_expense +
      endOfDayBalance;

    const diff = expectedCash - totalExpenses;

    // 👇 store signed value as string with prefix
    const signedDiff =
      diff > 0
        ? `-₹ ${Math.abs(diff)}`
        : diff < 0
        ? `+₹ ${Math.abs(diff)}`
        : "₹0";

    setFormData((prev) => ({
      ...prev,
      expectedCash,
      sortCash: signedDiff,
    }));
  }, [
    formData.openingBalance,
    formData.totalCashReceived,
    formData.cashWithdraw,
    formData.salaryExpense,
    formData.rmPurchaseExpense,
    formData.staffFoodExpense,
    formData.otherExpense,
    formData.mithinial_expense,
    formData.endOfDayBalance,
  ]);

  const handleInputChange = (field) => (event) => {
    setFormData((prev) => ({
      ...prev,
      [field]: event.target.value,
    }));
  };

  const handleFinalize = async () => {
    try {
      const payload = {
        cash_withdraw: Number(formData.cashWithdraw) || 0,
        salary: Number(formData.salaryExpense) || 0,
        rm_purchase: Number(formData.rmPurchaseExpense) || 0,
        staff_food: Number(formData.staffFoodExpense) || 0,
        other_expense: Number(formData.otherExpense) || 0,
        mithinial_expense: Number(formData.mithinial_expense) || 0,
        end_of_day_balance: Number(formData.endOfDayBalance) || 0,
        note: formData.note || "",
        is_finalized: 1, // 👈 mark as finalized
      };

      console.log("📤 Sending Finalize Payload:", payload);

      const res = await addExpense(payload);

      if (res?.success) {
        showSuccessToast("EOD finalized successfully");
        setIsFinalized(true); // ✅ lock the form
        onClose();
      } else {
        showErrorToast(res?.message || "End of Day already finalized!");
        console.error("❌ Finalize failed:", res?.message);
      }
    } catch (err) {
      console.error("API Error:", err);
      showErrorToast("Unexpected error occurred");
    }
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        cash_withdraw: Number(formData.cashWithdraw) || 0,
        salary: Number(formData.salaryExpense) || 0,
        rm_purchase: Number(formData.rmPurchaseExpense) || 0,
        staff_food: Number(formData.staffFoodExpense) || 0,
        other_expense: Number(formData.otherExpense) || 0,
        mithinial_expense: Number(formData.mithinial_expense) || 0,
        end_of_day_balance: Number(formData.endOfDayBalance) || 0,
        note: formData.note || "",
      };

      console.log("📤 Sending Update Payload:", payload);

      const res = await addExpense(payload);

      if (res?.success) {
        showSuccessToast("EOD updated successfully");
        window.location.reload();
      } else {
        showErrorToast(res?.message || "Failed to update expenses");
        console.error("❌ Failed to update:", res?.message);
      }
    } catch (err) {
      console.error("API Error:", err);
      showErrorToast("Unexpected error occurred");
    }
  };

  const InfoTooltip = ({ text }) => (
    <Tooltip title={text} placement="top">
      <InfoIcon
        sx={{ fontSize: 16, color: "#7a7a7a", ml: 0.5, cursor: "help" }}
      />
    </Tooltip>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "24px",
          backgroundColor: "#f2f2f2",
          height: "590px",
        },
      }}
    >
      <DialogTitle sx={{ position: "relative", pb: 1 }}>
        <Typography
          sx={{
            fontFamily: "Poppins",
            fontSize: "24px",
            fontWeight: "700",
            mb: 1,
          }}
        >
          End of the Day
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            width: 28,
            height: 28,
            p: 0,
            bgcolor: "#e74c3c",
            color: "white",
            borderRadius: "8px", // fully round
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
              bgcolor: "#c0392b",
            },
          }}
        >
          <CloseIcon fontSize="16px" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 2 }}>
        <Box sx={{ display: "flex", gap: 3 }}>
          {/* Left Panel - Summary */}
          <Card
            sx={{
              width: 230,
              height: "500px",
              borderRadius: "20px",
              backgroundColor: "white",
            }}
          >
            <CardContent sx={{ p: 1 }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                {/* Opening Time */}
                <Box sx={{ px: 1.5, py: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#7a7a7a",
                      fontFamily: "Poppins",
                    }}
                  >
                    Opening Day
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    {formData.openingTime?.split(" ")[0]}
                  </Typography>
                </Box>

                <Box sx={{ px: 1.5, py: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#7a7a7a",
                      fontFamily: "Poppins",
                    }}
                  >
                    Opening Balance
                  </Typography>

                  <Stack direction="row" alignItems="center" spacing={1}>
                    <TextField
                      variant="standard"
                      size="small"
                      type="number"
                      value={
                        formData.openingBalance === 0
                          ? ""
                          : formData.openingBalance
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        const num = Number(val);

                        setFormData((prev) => ({
                          ...prev,
                          openingBalance: val === "" ? 0 : Math.max(0, num), // prevent negative
                        }));
                      }}
                      InputProps={{
                        disableUnderline: true,
                        sx: {
                          fontSize: 20,
                          fontWeight: 500,
                          fontFamily: "Poppins",
                          "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                            {
                              WebkitAppearance: "none",
                              margin: 0,
                            },
                          "& input[type=number]": {
                            MozAppearance: "textfield",
                          },
                        },
                      }}
                      sx={{ width: 150 }}
                    />

                    <Button
                      size="small"
                      variant="contained"
                      sx={{
                        textTransform: "none",
                        fontFamily: "Poppins",
                        fontSize: 12,
                        borderRadius: "8px",
                        px: 1,
                        minWidth: "auto",
                        height: "25px",
                      }}
                      onClick={async () => {
                        try {
                          const res = await addOpeningBalance({
                            amount: formData.openingBalance,
                          });
                          if (res?.success) {
                            showSuccessToast(
                              "Opening balance saved successfully"
                            );
                            setFormData((prev) => ({
                              ...prev,
                              openingBalance: res.data.opening_balance,
                            }));
                          } else {
                            console.error("❌ Failed:", res?.message);
                          }
                        } catch (err) {
                          console.error("API Error:", err);
                        }
                      }}
                    >
                      Save
                    </Button>
                  </Stack>
                </Box>

                {/* Today's Total Orders */}
                <Box sx={{ px: 1.5, py: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#7a7a7a",
                      fontFamily: "Poppins",
                    }}
                  >
                    Today's Total Orders
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    {formData.todayOrders}
                  </Typography>
                </Box>

                {/* Today's Total Sales */}
                <Box sx={{ px: 1.5, py: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#7a7a7a",
                      fontFamily: "Poppins",
                    }}
                  >
                    Today's Total Sales
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    ₹{formData.todaySales.toLocaleString()}
                  </Typography>
                </Box>

                  {/* Total DISCOUNT Received */}
                <Box sx={{ px: 1.5, py: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#7a7a7a",
                      fontFamily: "Poppins",
                    }}
                  >
                    Today's Total Discount
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    ₹{formData.totalDiscount.toLocaleString()}
                  </Typography>
                </Box>

                {/* Total Cash Received */}
                <Box sx={{ px: 1.5, py: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#7a7a7a",
                      fontFamily: "Poppins",
                    }}
                  >
                    Total Cash(₹) Received
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    ₹{formData.totalCashReceived.toLocaleString()}
                  </Typography>
                </Box>

                {/* Total UPI Received */}
                <Box sx={{ px: 1.5, py: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#7a7a7a",
                      fontFamily: "Poppins",
                    }}
                  >
                    Total UPI(₹) Received
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 20,
                      fontWeight: 500,
                      fontFamily: "Poppins",
                    }}
                  >
                    ₹{formData.totalUpiReceived.toLocaleString()}
                  </Typography>
                </Box>
                <Box sx={{ px: 1.5, py: 0.5,  position: "sticky",
                    bottom: 0,
                    backgroundColor: "white",
                    pt: 1, }}>
                  <Button
                    fullWidth
                    onClick={handlePrint}
                    sx={{
                      backgroundColor: "#FFD33D",
                      color: "#000",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: 14,
                      py: 1,
                      borderRadius: "8px",
                      height: "38px",
                      "&:hover": { backgroundColor: "#FFD33D" },
                      textTransform: "none",
                    }}
                  >
                    Print Report
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>

          {/* Right Panel - Form */}
          <Box sx={{ flex: 1, height: "450px", width: "440px" }}>
            {/* Expected Cash */}
            <Paper
              sx={{
                mb: 2,
                p: 1.5,
                borderRadius: "8px",
                border: "1px solid #c7c7c7",
                height: "44px",
                backgroundColor: "white",
                boxShadow: "none",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{ fontSize: 16, color: "#7a7a7a", fontFamily: "Poppins" }}
                >
                  Diffrence In Cash (As per System)
                </Typography>
                <Typography
                  sx={{ fontSize: 20, fontWeight: 500, fontFamily: "Poppins" }}
                >
                  {formData.sortCash}
                </Typography>
              </Box>
            </Paper>

            {/* Expense Fields */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={6}>
                <Box sx={{ mb: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: "Poppins",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Cash Withdraw
                    <InfoTooltip text="Helper Text" />
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  placeholder="Enter withdraw amount"
                  value={formData.cashWithdraw}
                  // onChange={handleInputChange('cashWithdraw')}
                  onChange={(e) => {
                    const val = e.target.value;
                    const num = Number(val);

                    setFormData((prev) => ({
                      ...prev,
                      cashWithdraw: val === "" ? "" : Math.max(0, num), // 🚫 clamp negatives to 0
                    }));
                  }}
                  type="number"
                  inputProps={{
                    min: 0, // 🚫 no negative values
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: "8px",
                      height: "34px",
                      width: "299px",
                      "& fieldset": { borderColor: "#c7c7c7" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <Box sx={{ mb: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: "Poppins",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Other Expense
                    <InfoTooltip text="Helper Text" />
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  placeholder="Enter expense amount"
                  value={formData.otherExpense}
                  // onChange={handleInputChange('otherExpense')}
                  onChange={(e) => {
                    const val = e.target.value;
                    const num = Number(val);

                    setFormData((prev) => ({
                      ...prev,
                      otherExpense: val === "" ? "" : Math.max(0, num), // 🚫 clamp negatives to 0
                    }));
                  }}
                  type="number"
                  inputProps={{
                    min: 0, // 🚫 no negative values
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: "8px",
                      height: "34px",
                      width: "299px",
                      "& fieldset": { borderColor: "#c7c7c7" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <Box sx={{ mb: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: "Poppins",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Salary Expense
                    <InfoTooltip text="Helper Text" />
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  placeholder="Enter expense amount"
                  value={formData.salaryExpense}
                  // onChange={handleInputChange('salaryExpense')}
                  onChange={(e) => {
                    const val = e.target.value;
                    const num = Number(val);

                    setFormData((prev) => ({
                      ...prev,
                      salaryExpense: val === "" ? "" : Math.max(0, num), // 🚫 clamp negatives to 0
                    }));
                  }}
                  type="number"
                  inputProps={{
                    min: 0, // 🚫 no negative values
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: "8px",
                      height: "34px",
                      width: "299px",
                      "& fieldset": { borderColor: "#c7c7c7" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <Box sx={{ mb: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: "Poppins",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    RM Purchase Expense
                    <InfoTooltip text="Helper Text" />
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  placeholder="Enter expense amount"
                  value={formData.rmPurchaseExpense}
                  // onChange={handleInputChange('rmPurchaseExpense')}
                  onChange={(e) => {
                    const val = e.target.value;
                    const num = Number(val);

                    setFormData((prev) => ({
                      ...prev,
                      rmPurchaseExpense: val === "" ? "" : Math.max(0, num), // 🚫 clamp negatives to 0
                    }));
                  }}
                  type="number"
                  inputProps={{
                    min: 0, // 🚫 no negative values
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: "8px",
                      height: "34px",
                      width: "299px",
                      "& fieldset": { borderColor: "#c7c7c7" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <Box sx={{ mb: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: "Poppins",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    Staff Food Expense
                    <InfoTooltip text="Helper Text" />
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  placeholder="Enter expense amount"
                  value={formData.staffFoodExpense}
                  onChange={(e) => {
                    const val = e.target.value;
                    const num = Number(val);

                    setFormData((prev) => ({
                      ...prev,
                      staffFoodExpense: val === "" ? "" : Math.max(0, num), // 🚫 clamp negatives to 0
                    }));
                  }}
                  type="number"
                  inputProps={{
                    min: 0, // still keep this for arrow keys
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: "8px",
                      height: "34px",
                      width: "299px",
                      "& fieldset": { borderColor: "#c7c7c7" },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <Box sx={{ mb: 0.5 }}>
                  <Typography
                    sx={{
                      fontSize: 12,
                      fontFamily: "Poppins",
                      display: "flex",
                      alignItems: "center",
                      color: "#555", // dim label color for clarity
                    }}
                  >
                    Miscellaneous Expense
                    <InfoTooltip text="Helper Text" />
                  </Typography>
                </Box>
                <TextField
                  fullWidth
                  placeholder="Enter expense amount"
                  value={formData.mithinial_expense}
                  onChange={handleInputChange("mithinial_expense")}
                  type="number"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                      borderRadius: "8px",
                      height: "34px",
                      width: "299px",
                      "& fieldset": { borderColor: "#c7c7c7" },
                    },
                  }}
                />
              </Grid>
            </Grid>

            {/* End of Day Balance */}
            <Box sx={{ mb: 2 }}>
              <Box sx={{ mb: 0.5 }}>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontFamily: "Poppins",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Closing Balance
                  <InfoTooltip text="Helper Text" />
                </Typography>
              </Box>
              <TextField
                fullWidth
                placeholder="Enter Amount"
                value={formData.endOfDayBalance}
                onChange={(e) => {
                  if (isFinalized) return; // 👈 prevent edit
                  const val = e.target.value;
                  const num = Number(val);
                  setFormData((prev) => ({
                    ...prev,
                    endOfDayBalance: val === "" ? "" : Math.max(0, num),
                  }));
                }}
                type="number"
                inputProps={{
                  min: 0, // 🚫 no negative values
                  readOnly: isFinalized,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                    borderRadius: "8px",
                    height: "34px",
                    width: "615px",
                    "& fieldset": { borderColor: "#c7c7c7" },
                  },
                }}
              />
            </Box>

            {/* Note */}
            <Box sx={{ mb: 2 }}>
              <Box sx={{ mb: 0.5 }}>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontFamily: "Poppins",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Note
                  <InfoTooltip text="Helper Text" />
                </Typography>
              </Box>
              <TextField
                fullWidth
                placeholder="Add Note"
                value={formData.note}
                onChange={handleInputChange("note")}
                // multiline
                // rows={2}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "white",
                    borderRadius: "8px",
                    height: "34px",
                    width: "615px",
                    "& fieldset": { borderColor: "#c7c7c7" },
                  },
                }}
              />
            </Box>

            <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
              <Button
                fullWidth
                onClick={handleUpdate}
                disabled={isFinalized}
                sx={{
                  backgroundColor: isFinalized ? "#ccc" : "#3F6CFF",
                  color: isFinalized ? "#666" : "white",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: 14,
                  py: 1,
                  borderRadius: "8px",
                  height: "38px",
                  "&:hover": { backgroundColor: "#3F6CFF" },
                  textTransform: "none",
                }}
              >
                Update
              </Button>
              <Button
                fullWidth
                onClick={handleFinalize}
                disabled={isFinalized}
                sx={{
                  backgroundColor: "#ffd33d",
                  color: "black",
                  fontFamily: "Poppins",
                  fontWeight: 500,
                  fontSize: 14,
                  py: 1,
                  borderRadius: "8px",
                  height: "38px",
                  "&:hover": { backgroundColor: "#ffce1a" },
                  textTransform: "none",
                }}
              >
                Finalize End Day Cash Count
              </Button>
            </Stack>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
